import Rails from '@rails/ujs';
window.Rails = Rails;
